import Pause from '@mui/icons-material/Pause';
import PlayArrow from '@mui/icons-material/PlayArrow';
import {Box} from '@mui/material';
import IconButton from '@mui/material/IconButton';

interface Props {
  isPlaying: boolean;
  togglePlay: () => void;
  children: React.ReactNode;
}

const AurVideoControls = ({isPlaying, togglePlay, children}: Props) => {
  return (
    <Box className="controls" data-testid="aur-video-controls">
      <IconButton
        onClick={togglePlay}
        data-testid="aur-video-play-pause-button"
      >
        {isPlaying ? (
          <Pause data-testid="aur-video-pause-icon" />
        ) : (
          <PlayArrow data-testid="aur-video-play-icon" />
        )}
      </IconButton>

      {children}
    </Box>
  );
};

export default AurVideoControls;
